import { render, staticRenderFns } from "./StockTextPopularItem.vue?vue&type=template&id=4688690a"
import script from "./StockTextPopularItem.vue?vue&type=script&lang=js"
export * from "./StockTextPopularItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports